window.onload = function () {
  selectAddressCard();  
};

function selectAddressCard() {
  let addressCards = document.getElementById("address-grp").children;
  let activeAddressCard = null;

  function resetAddressCards() {
    if (activeAddressCard) {
      activeAddressCard.classList.remove("address-grp-container-active");
    }
  }

  function activateAddressCard(card) {
    resetAddressCards();
    card.classList.add("address-grp-container-active");
    activeAddressCard = card;
  }

  if (addressCards.length > 0) {
    activateAddressCard(addressCards[0]);
  }

  for (let i = 0; i < addressCards.length; i++) {
    addressCards[i].addEventListener("click", function () {
      if (this.id.includes("address-grp_")) {
        activateAddressCard(this);
      }
    });
  }
}







